import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import Seo from "../components/Seo";

export default function Categories() {
  const [cats, setCats] = useState([]);
  useEffect(() => {
    api.get("/categories").then((r) => setCats(r.data));
  }, []);

  return (
    <div className="max-w-[1100px] mx-auto px-4 md:px-8 py-10 md:py-14" data-testid="categories-page">
      <Seo
        title="All topics"
        description="Browse IndiaODR by intelligence vertical — ICC, ICSID, UNCITRAL, India arbitration, award enforcement, set-aside, AI in arbitration, digital hearings and more."
        path="/categories"
      />
      <div className="eyebrow">Browse by topic</div>
      <h1 className="font-serif text-[44px] md:text-[56px] mt-2 text-[var(--io-text)]">All intelligence verticals</h1>
      <p className="mt-3 text-[15px] text-[var(--io-text-2)] max-w-2xl">Deep-dive verticals across arbitration, ODR, institutions and case law.</p>

      <div className="mt-10 grid md:grid-cols-2 gap-3">
        {cats.map((c) => (
          <Link key={c.slug} to={`/category/${c.slug}`} className="io-card p-5 group flex items-center justify-between" data-testid={`topic-${c.slug}`}>
            <div>
              <div className="eyebrow">{c.count} article{c.count !== 1 ? "s" : ""}</div>
              <h3 className="font-serif text-[22px] mt-1 text-[var(--io-text)] group-hover:text-[var(--io-gold)]">{c.name}</h3>
            </div>
            <span className="font-mono text-[11px] text-[var(--io-muted)] group-hover:text-[var(--io-gold)]">Open →</span>
          </Link>
        ))}
      </div>
    </div>
  );
}
